export default __webpack_public_path__ + "static/bg-shadow-3a772a20310c716ebf1380e357ee201a.svg";